/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/destructuring-assignment */
import {
  CSSProperties,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
  memo,
} from 'react';
import { Layout, Button, Skeleton, message, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import classNames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { Translate } from '../../ui';
import { setPanelExpand, themeStyle } from '../../../app/theme/themeSlice';
import {
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from '../../../constants/theme.constant';
import LogoImage from '../../../assets/bracLogoFullCut.png';
import SmallLogoImage from '../../../assets/load.png';
// import Icons from '../../../configs/icon.config';
import Icons from '../../../configs/icon.config';

import {
  commonState,
  setCurrentRouteKey,
  setMobileMenuDrawerClose,
} from '../../../app/base/commonSlice';
import adminMenuItems from '../../../configs/admin-menu.config';
import { authState } from '../../../app/auth/authSlice';
import getMenuItemKey, {
  getFavMenuItemKey,
} from '../../../utils/getMenuItemKey';
import authorityGuard from '../../../utils/authorityGuard';
import './styles.scss';
import {
  useAddFavoriteListMutation,
  useDeleteFavoriteListMutation,
  useGetSideNavFavoritesMenusQuery,
  useGetSideNavMenusQuery,
} from '../../Admin/Menu/store/menuAdminSlice';
import { TourContext } from '../../layout';
import Errormsg from '../../../utils/handleError';
import reducer from './store';
import { injectReducer } from '../../../app/index';
import { setFavoriteMenuOpen, menuState } from './store/stateSlice';

// eslint-disable-next-line @typescript-eslint/no-empty-interface

const { Sider } = Layout;

type LogoProps = {
  logoKey?: string | number;
  image?: string;
  style?: CSSProperties;
  alt?: string;
};

function Logo(props: LogoProps) {
  const { logoKey, image, style, alt } = props;

  const { t } = useTranslation();

  return (
    <div>
      <Tooltip placement="right" title={`${t('bracLogo.tooltip')}`}>
        <motion.img
          key={logoKey}
          src={image}
          style={style}
          alt={alt}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        />
      </Tooltip>
    </div>
  );
}

injectReducer('menu', reducer);

// eslint-disable-next-line react/display-name
const SubMenuMenu = memo(({ item }: any) => {
  const menuTour: any = useContext(TourContext);
  const dispatch = useDispatch();
  const { panelExpand } = useSelector(themeStyle);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { currentRouteKey, isMenuOpen, isAdmin } = useSelector(commonState);
  const [addFavoriteId, setAddFavoriteId] = useState<string | number>('');
  const [deleteFavoriteId, setDeleteFavoriteId] = useState<string | number>('');
  const [selectedMenu, setSelectedMenu] = useState(false);
  const { profile } = useSelector(authState);
  const [deleteFavoriteList, { isLoading: deleteLoading }] =
    useDeleteFavoriteListMutation();
  const [addFavoriteList, { isLoading: favoriteLoading }] =
    useAddFavoriteListMutation();

  const [tooltipShow, setTooltipShow] = useState(true);

  const handleOpenMenu = () => {
    // if the favorite menu is open then the isFavoriteMenuOpen's value set false to true
    dispatch(setFavoriteMenuOpen(false));

    if (currentRouteKey === item.id) {
      setSelectedMenu(false);
      dispatch(setCurrentRouteKey({ open: false, id: '' }));
    } else {
      setSelectedMenu((prev) => !prev);
    }
  };

  const handleMenuItemClick = useCallback(() => {
    setTooltipShow(false);
    if (isMobile) dispatch(setMobileMenuDrawerClose(false));
  }, [dispatch, isMobile]);

  const handleDeleteFavorite = useCallback(
    async (e: any, id: string | number) => {
      setDeleteFavoriteId(id);
      e.preventDefault();
      try {
        await deleteFavoriteList(id).unwrap();
        message.success('Removed successfully');
      } catch (errors: any) {
        Errormsg(errors);
      }
    },
    [deleteFavoriteList]
  );

  const handleAddFavorite = useCallback(
    async (e: any, id: string | number) => {
      setAddFavoriteId(id);
      e.preventDefault();
      try {
        await addFavoriteList({ submenu_item: id, user: profile.id }).unwrap();
        message.success('Added successfully');
      } catch (errors: any) {
        Errormsg(errors);
      }
    },
    [addFavoriteList, profile.id]
  );

  let filterSubItems: any[] = [];

  if (isAdmin) {
    filterSubItems = item?.sub_menu_items?.filter((smi: any) => {
      return authorityGuard(smi?.authority);
    });
  } else {
    filterSubItems = item.sub_menu_items;
  }

  const menuItem = () => (
    <SubMenu
      ref={item.id === 'favorite-1' ? menuTour.favMenuRef : null}
      rootStyles={{
        padding: 0,
        marginBottom: 10,
      }}
      prefix={
        <div
          className="absolute left-0 top-0"
          style={{
            height: 35,
            width: 15,
            background: item.color,
          }}
        />
      }
      icon={
        <div
          style={{
            transition: 'all .3s',
            marginLeft: panelExpand ? 10 : 0,
          }}
          className="text-3xl mr-0"
        >
          {Icons[item?.icon_name]}
        </div>
      }
      label={<Translate en={item.title_en} bn={item.title_bn} />}
      className={classNames('relative', {
        'mb-menu-item': !panelExpand,
      })}
      component={
        <div
          style={{
            height: 35,
            background:
              (currentRouteKey === item.id && isMenuOpen) || selectedMenu
                ? item.color
                : '',
          }}
        />
      }
      onOpenChange={handleOpenMenu}
      open={(currentRouteKey === item.id && isMenuOpen) || selectedMenu}
      active={(currentRouteKey === item.id && isMenuOpen) || selectedMenu}
    >
      {filterSubItems?.map((sm: any) => {
        return (
          // <AuthorityGuard key={sm?.id} authority={sm?.authority}>
          <MenuItem
            disabled={profile?.user_settings?.guided_tour}
            onClick={handleMenuItemClick}
            key={sm?.id}
            component={
              <NavLink
                className="menu-item"
                to={sm?.url}
                style={({ isActive }) => {
                  return {
                    padding: '5px 10px 5px 35px',
                    height: 'inherit',
                    color: isActive ? item.color : '',
                    textDecoration: isActive ? 'underline' : 'inherit',
                    textTransform: isActive ? 'uppercase' : 'inherit',
                  };
                }}
                target={sm?.url.startsWith('http') ? '_blank' : '_self'}
              />
            }
            suffix={
              !isAdmin && (
                <div>
                  {item?.isFavorite || sm.is_favorite ? (
                    <button
                      className="p-0 bg-transparent hover:!bg-transparent hover:scale-125"
                      disabled={deleteLoading && sm?.id === deleteFavoriteId}
                      onClick={(e) => handleDeleteFavorite(e, sm.id)}
                    >
                      {Icons.starFill}
                    </button>
                  ) : (
                    <button
                      className="p-0 bg-transparent hover:!bg-transparent hover:scale-125"
                      disabled={favoriteLoading && sm.id === addFavoriteId}
                      onClick={(e) => handleAddFavorite(e, sm.id)}
                    >
                      {Icons.star}
                    </button>
                  )}
                </div>
              )
            }
          >
            <div className="flex items-center gap-6">
              <div className="text-3xl ml-1" style={{ color: item.color }}>
                {Icons[sm?.icon_name]}
              </div>
              <span className="mt-1 leading-8">
                <Translate en={sm.title_en} bn={sm.title_bn} />
              </span>
            </div>
          </MenuItem>
          // </AuthorityGuard>
        );
      })}
    </SubMenu>
  );

  return (
    <>
      {panelExpand && !isMobile ? (
        <Tooltip
          trigger={['click', 'hover']}
          title={
            tooltipShow ? (
              <Translate en={item.title_en} bn={item.title_bn} />
            ) : (
              ''
            )
          }
        >
          {menuItem()}
        </Tooltip>
      ) : (
        <>{menuItem()}</>
      )}
    </>
  );
});

// eslint-disable-next-line react/display-name
export const CustomMenu = memo(() => {
  const { isFavoriteMenuOpen } = useSelector(menuState);
  const menuTour: any = useContext(TourContext);
  const dispatch = useDispatch();
  const { data: menuData, isLoading } = useGetSideNavMenusQuery();
  const { data: favoriteMenuData } = useGetSideNavFavoritesMenusQuery(
    undefined,
    { skip: isFavoriteMenuOpen }
  );
  const location = useLocation();

  const currentURL = location.pathname;

  const { panelExpand, mode } = useSelector(themeStyle);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { isAdmin } = useSelector(commonState);
  const isAdminUrl = currentURL.startsWith('/admin');
  const themeMode = mode === 'light';

  const menuItem = useMemo(() => {
    return isAdmin
      ? adminMenuItems?.filter((smi) => {
          return authorityGuard(smi?.authority);
        })
      : menuData?.map((data) => {
          const favoriteMenu = favoriteMenuData?.filter(
            (item) => item?.menu_item_id === data?.id
          );
          if (!isEmpty(favoriteMenu)) {
            // store favorite menu's id to here to generate is favorite true
            const favoriteMenuIds = new Set(
              // @ts-ignore
              favoriteMenuData?.map((item) => item.submenu_item?.id)
            );
            return {
              ...data,
              // Favorite menu data comes from different APIs. so to show the favorite star icon fill here we generate the favorite is_favorite variable
              sub_menu_items: data?.sub_menu_items?.map((item) => ({
                ...item,
                is_favorite: favoriteMenuIds.has(item.id),
              })),
            };
          }
          return data;
        });
  }, [favoriteMenuData, isAdmin, menuData]);

  const favoriteMenuItem = useMemo(() => {
    return {
      action: 'SUBMENU',
      color: '#eb3e8e',
      icon_name: 'star',
      id: 'favorite-1',
      is_active: true,
      menu: 1,
      order: 1,
      title_bn: 'প্রিয় মেন্যু',
      title_en: 'Favourites',
      url: '',
      isFavorite: true,
      sub_menu_items: favoriteMenuData?.map((item) => item?.submenu_item),
    };
  }, [favoriteMenuData]);

  /** The below code is deprecated for this moment */

  // useEffect(() => {
  //   // if (currentRouteKey === 'favorite-1') {
  //   // dispatch(setCurrentRouteKey({ open: true, id: 'favorite-1' }));
  //   dispatch(
  //     setCurrentRouteKey(
  //       getFavMenuItemKey(favoritemenuData, currentURL, 'favorite')
  //     )
  //   );

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [favoritemenuData, isAdminUrl]);

  useEffect(() => {
    if (!isAdminUrl) {
      const favMenu = getFavMenuItemKey(
        favoriteMenuData,
        currentURL,
        'favorite'
      );
      if (!isEmpty(favMenu)) {
        dispatch(setCurrentRouteKey(favMenu));
      } else {
        dispatch(setCurrentRouteKey(getMenuItemKey(menuData, currentURL)));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, favoriteMenuData, isAdminUrl, menuData]);

  useEffect(() => {
    if (isAdminUrl) {
      dispatch(setCurrentRouteKey(getMenuItemKey(adminMenuItems, currentURL)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isAdminUrl]);

  return (
    <Sidebar
      backgroundColor={themeMode ? '#fff' : '#323232'}
      collapsed={panelExpand && !isMobile}
      width={`${SIDE_NAV_WIDTH}`}
      rootStyles={{
        border: 'none',
      }}
      className="text-[15px]"
    >
      {isLoading ? (
        <Skeleton active />
      ) : (
        <div
          ref={menuTour.menuRef}
          style={{
            height: isMobile ? 'inherit' : 'calc(100vh - 100px)',
            paddingBottom: isMobile ? '50px' : 'inherit',
          }}
        >
          <PerfectScrollbar
            options={{
              wheelPropagation: isMobile || false,
              suppressScrollX: true,
              useBothWheelAxes: false,
            }}
          >
            <Menu className="relative mb-menu">
              {!isAdmin && (
                <SubMenuMenu
                  ref={menuTour.favMenuRef}
                  item={favoriteMenuItem}
                />
              )}
              {menuItem?.map((item) => {
                return <SubMenuMenu key={item.id} item={item} />;
              })}
            </Menu>
          </PerfectScrollbar>
        </div>
      )}
    </Sidebar>
  );
});

function SideNav() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { panelExpand, mode } = useSelector(themeStyle);
  const { isAdmin } = useSelector(commonState);
  const sideBarMode = mode === 'light';
  const handleCollapseClick = useCallback(() => {
    dispatch(setPanelExpand(!panelExpand));
  }, [dispatch, panelExpand]);

  return (
    <Sider
      style={{
        position: 'sticky',
        zIndex: '11',
        boxShadow: '20px 0px 30px #00000012',
        background: sideBarMode ? '#fff' : '#323232',
      }}
      theme="light"
      trigger={null}
      collapsible
      width={SIDE_NAV_WIDTH}
      collapsedWidth={SIDE_NAV_COLLAPSED_WIDTH}
      collapsed={panelExpand}
    >
      <div data-testid="side-nav-wrapper" className="side-nav-wrapper">
        <div>
          <div data-testid="logo-section" className="logo-section">
            <Link to={isAdmin ? '/admin' : '/'}>
              <div className="logo-wrapper">
                {panelExpand ? (
                  <div>
                    <Logo
                      key={1}
                      logoKey={1}
                      image={SmallLogoImage}
                      alt="logo"
                      style={{
                        width: 35,
                        marginLeft: '7px',
                      }}
                    />
                  </div>
                ) : (
                  <Logo
                    style={{ marginLeft: '14px' }}
                    logoKey={2}
                    key={2}
                    image={LogoImage}
                    alt="logo"
                  />
                )}
              </div>
            </Link>
            <Tooltip
              title={
                panelExpand
                  ? `${t('sidemenuOpenButton.tooltip')}`
                  : `${t('sidemenuCollapseButton.tooltip')}`
              }
            >
              <Button
                shape="circle"
                onClick={handleCollapseClick}
                icon={panelExpand ? Icons.chevronRight : Icons.chevronLeft}
                className="collapse-icon"
              />
            </Tooltip>
          </div>
          <hr className="mb-12" style={{ opacity: !sideBarMode ? '.2' : 1 }} />
        </div>
        <CustomMenu />
      </div>
    </Sider>
  );
}

export default memo(SideNav);
